// extracted by mini-css-extract-plugin
export default {"statisticsWrapper":"Statisticts_statisticsWrapper__vuiPe"};